const TIME_FORMAT = 'h:mma';
const DATE_FORMAT = 'YYYY-MM-DD';
const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
const COURSE_CSF = 'CS Fundamentals';
const COURSE_CSD = 'CS Discoveries';
const COURSE_CSP = 'CS Principles';
const COURSE_CSA = 'Computer Science A';
const COURSE_BUILD_YOUR_OWN = 'Build Your Own Workshop';

const MAX_SESSIONS = 10;

export {
  TIME_FORMAT,
  DATE_FORMAT,
  DATETIME_FORMAT,
  MAX_SESSIONS,
  COURSE_CSF,
  COURSE_CSD,
  COURSE_CSP,
  COURSE_CSA,
  COURSE_BUILD_YOUR_OWN,
};
